module.exports = " <div id=public> <layout v-if=isReady></layout> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/PubApp.vue
// module id = 146
// module chunks = 0